// Configuration des textes du site
// Structure permettant une future internationalisation

export const texts = {
  fr: {
    // Textes de navigation
    nav: {
      home: 'Accueil',
      rooms: 'Chambres',
      businessStay: 'Soirées Étapes',
      restaurant: 'Restaurant',
      region: 'Aux alentours',
      contact: 'Contact',
    },
    
    // Textes communs
    common: {
      readMore: 'Découvrir nos chambres',
      bookNow: 'Réserver maintenant',
      contactUs: 'Nous contacter',
      seeMenu: 'Notre restaurant',
      callNow: 'Appeler maintenant',
      sendEmail: 'Envoyer un email',
      discover: 'Découvrir',
    },
    
    // Page d'accueil
    home: {
      hero: {
        title: 'Bienvenue à l\'Hôtel Saint-Pierre',
        subtitle: 'Un séjour authentique au cœur de la Normandie',
      },
      about: {
        title: 'Notre Hôtel',
        description: 'L\'Hôtel Saint-Pierre est un bâtiment historique construit en 1905, qui conserve le charme et le caractère authentique du patrimoine normand. Il est situé au cœur du centre historique de Villedieu-les-Poêles, une ville connue pour son artisanat du cuivre.',
      },
      rooms: {
        title: 'Nos Chambres',
        description: 'Découvrez nos chambres confortables, toutes équipées de salles de bains privatives.',
      },
      restaurant: {
        title: 'Notre Restaurant',
        description: 'Savourez une cuisine traditionnelle normande dans notre restaurant ou notre brasserie.',
      },
      region: {
        title: 'La Région',
        description: 'Explorez les merveilles de la Normandie depuis notre établissement idéalement situé.',
      },
    },
    
    // Restaurant
    restaurant: {
      pageTitle: 'Notre Restaurant',
      intro: {
        title: 'Le Restaurant Saint-Pierre',
        description: 'Notre chef vous propose une cuisine traditionnelle normande entièrement faite maison. Tous nos plats sont élaborés sur place à partir de produits frais et locaux. En plus de nos menus, vous pourrez déguster des salades, burgers et autres options de snacking dans une ambiance chaleureuse et conviviale.',
      },
      menus: {
        title: 'Nos Menus',
        options: {
          option1: 'Entrée + Plat',
          option2: 'Plat + Dessert',
          option3: 'Entrée + Plat + Dessert'
        }
      },
      footer: {
        priceInfo: 'Prix nets, service compris.',
        dailyMenu: 'Le menu de la brasserie change tous les jours, n\'hésitez pas à nous demander les suggestions du jour.',
      },
      sections: {
        starters: 'Entrées',
        mains: 'Plats',
        desserts: 'Desserts',
      },
      preview: {
        title: 'Notre Restaurant',
        cuisine: 'Notre cuisine',
        description1: 'Notre chef vous propose une cuisine traditionnelle normande élaborée à partir de produits frais et de saison. Vous pourrez déguster nos spécialités régionales dans un cadre chaleureux et convivial.',
        button: 'Découvrir notre restaurant',
      },
    },
    
    // Page Chambres
    rooms: {
      pageTitle: 'Nos Chambres',
      sectionTitle: 'Nos chambres',
      priceFrom: 'À partir de {price}€*',
      viewDetails: 'Voir détails',
      viewAll: 'Voir toutes nos chambres',
      intro: {
        title: 'Hébergement',
        description: 'Toutes nos chambres sont équipées de salles de bains privatives, télévision et accès internet. Nous proposons différentes catégories pour répondre à tous vos besoins.',
      },
    },
    
    // Page Région
    region: {
      pageTitle: 'Aux alentours',
      discoverRegion: 'Découvrir la région',
      distanceFrom: 'à {distance} de l\'hôtel',
      otherPlaces: 'Autres lieux à découvrir',
      advice1: 'N\'hésitez pas à demander des conseils à notre réception pour organiser vos visites.',
      advice2: 'Nous pouvons vous fournir des cartes et des informations sur les horaires d\'ouverture des sites touristiques.',
      intro: {
        title: 'Découvrez la Normandie',
        description: 'Située au cœur de la Manche, Villedieu-les-Poêles est le point de départ idéal pour explorer les merveilles de la Normandie.',
      },
      distance: 'À {distance} de l\'hôtel',
    },
    
    // Page Contact
    contact: {
      pageTitle: 'Contact & Accès',
      info: {
        title: 'Nous contacter',
        address: 'Adresse',
        phone: 'Téléphone',
        email: 'Email',
        openingHours: 'Horaires d\'ouverture',
      },
      reservation: {
        title: 'Réservations',
        description: 'Pour réserver une chambre ou une table au restaurant, vous pouvez nous contacter par téléphone ou par email. Nous vous répondrons dans les plus brefs délais pour confirmer votre réservation.',
      },
      location: {
        description: 'Nous sommes situés en plein centre-ville de Villedieu-les-Poêles, à proximité de tous les commerces et attractions.',
        parking: 'Parking privé disponible.',
      },
    },
    
    // Footer
    footer: {
      address: 'Adresse',
      contact: 'Contact',
      about: 'À propos',
      quickLinks: 'Liens rapides',
      openingHours: 'Horaires d\'ouverture',
      legalNotice: 'Mentions légales',
    },
    
    // Features
    features: {
      title: 'Pourquoi choisir l\'Hôtel Saint-Pierre',
      items: {
        comfortable: {
          title: 'Chambres confortables',
          description: '20 chambres tout confort avec salle de bain privative pour un séjour agréable.'
        },
        restaurant: {
          title: 'Restaurant traditionnel',
          description: 'Cuisine normande traditionnelle avec des produits frais et de saison.'
        },
        historic: {
          title: 'Bâtiment historique',
          description: 'Construit en 1905, notre hôtel conserve le charme et le caractère authentique du patrimoine normand.'
        },
        wifi: {
          title: 'Wi-Fi gratuit',
          description: 'Restez connecté pendant votre séjour avec notre Wi-Fi haut débit gratuit.'
        },
        location: {
          title: 'Emplacement central',
          description: 'Situé au cœur de Villedieu-les-Poêles, à proximité des attractions touristiques.'
        },
        welcome: {
          title: 'Accueil chaleureux',
          description: 'Notre équipe vous accueille chaleureusement pour rendre votre séjour inoubliable.'
        }
      }
    },
    
    // Bannière de cookies
    cookieBanner: {
      message: 'Ce site utilise Google Analytics pour analyser le trafic. En continuant à naviguer, vous acceptez notre utilisation des cookies.',
      accept: 'Accepter',
      decline: 'Refuser',
      moreInfo: 'En savoir plus'
    },
    
    // Page Mentions Légales
    legalNotice: {
      pageTitle: 'Mentions Légales',
      title: 'Mentions Légales',
      lastUpdate: 'Dernière mise à jour : {date}',
      sections: {
        hotelInfo: {
          title: 'Informations sur l\'établissement',
          content: 'Hôtel Saint-Pierre\nSARL au capital de 10 000€\nSIRET : 500 089 487 00010\nTVA Intracommunautaire : FR16500089487\nAdresse : 12 Place de la République, 50800 Villedieu-les-Poêles\nTéléphone : +33 (0)2 33 61 00 11\nEmail : st.pierre.hotel@wanadoo.fr'
        },
        hosting: {
          title: 'Hébergement du site',
          content: 'Ce site est hébergé par la société OVH\nSAS au capital de 50 000 000 €\nRCS Lille Métropole 424 761 419 00045\nSiège social : 2 rue Kellermann - 59100 Roubaix - France\nTéléphone : +33 (0)8 99 70 17 61'
        },
        intellectualProperty: {
          title: 'Propriété intellectuelle',
          content: 'L\'ensemble de ce site (structure, textes, logos, images, photographies, vidéos, sons, savoir-faire, etc.) relève de la législation française et internationale sur le droit d\'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.\n\nCertaines photographies utilisées sur ce site sont sous licence Unsplash, qui permet leur utilisation libre sans attribution. Les autres éléments visuels sont la propriété de l\'Hôtel Saint-Pierre ou ont été acquis avec les droits d\'utilisation appropriés.\n\nLa reproduction de tout ou partie de ce site sur un support électronique ou autre est formellement interdite sauf autorisation expresse de l\'Hôtel Saint-Pierre. Toute exploitation non autorisée du site ou de son contenu engagerait la responsabilité de l\'utilisateur et constituerait une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.'
        },
        cookies: {
          title: 'Gestion des cookies',
          content: 'Ce site utilise Google Analytics, un service d\'analyse web fourni par Google qui utilise des cookies pour nous aider à analyser l\'utilisation du site par ses visiteurs. Les informations générées par les cookies concernant votre utilisation du site sont transmises et stockées par Google sur des serveurs situés aux États-Unis.\n\nGoogle Analytics est configuré pour anonymiser votre adresse IP avant de l\'envoyer à Google, ce qui empêche de vous identifier personnellement. Google utilise ces informations pour évaluer votre utilisation du site, compiler des rapports sur l\'activité du site et fournir d\'autres services relatifs à l\'activité du site et à l\'utilisation d\'Internet.\n\nConformément au Règlement Général sur la Protection des Données (RGPD) et à la directive européenne ePrivacy, notre site dispose d\'une bannière de consentement aux cookies qui vous permet d\'accepter ou de refuser les cookies avant leur installation. Si vous refusez les cookies, Google Analytics sera automatiquement désactivé pour votre session.\n\nVous pouvez également refuser l\'utilisation de cookies en sélectionnant les paramètres appropriés dans votre navigateur. Cependant, veuillez noter que si vous faites cela, vous ne pourrez peut-être pas utiliser toutes les fonctionnalités de ce site.\n\nPour en savoir plus sur les cookies et comment les gérer, consultez le site de la CNIL : www.cnil.fr.'
        },
        disclaimer: {
          title: 'Limitation de responsabilité',
          content: 'L\'Hôtel Saint-Pierre s\'efforce d\'assurer l\'exactitude et la mise à jour des informations diffusées sur ce site, dont il se réserve le droit de corriger, à tout moment et sans préavis, le contenu. Toutefois, l\'Hôtel Saint-Pierre ne peut garantir l\'exactitude, la précision ou l\'exhaustivité des informations mises à disposition sur ce site.\n\nEn conséquence, l\'Hôtel Saint-Pierre décline toute responsabilité pour tout dommage résultant notamment d\'une imprécision ou inexactitude des informations disponibles sur ce site, ou pour toute atteinte résultant d\'une intrusion frauduleuse d\'un tiers ayant entraîné une modification des informations mises à la disposition sur ce site.\n\nL\'Hôtel Saint-Pierre ne saurait être tenu responsable des éléments en dehors de son contrôle et des dommages qui pourraient éventuellement être subis par votre environnement technique, notamment vos ordinateurs, logiciels, équipements réseaux et tout autre matériel utilisé pour accéder à ou utiliser le service et/ou les informations.'
        },
        links: {
          title: 'Liens hypertextes',
          content: 'Les liens hypertextes établis en direction d\'autres sites à partir de www.st-pierre-hotel.com ne sauraient, en aucun cas, engager la responsabilité de l\'Hôtel Saint-Pierre, notamment en ce qui concerne le contenu de ces sites.\n\nL\'Hôtel Saint-Pierre n\'est pas responsable des liens hypertextes pointant vers son site et dégage toute responsabilité concernant le contenu des sites proposant un lien vers le site www.st-pierre-hotel.com.'
        }
      }
    },
    

    

  },
  
  // Traduction en anglais
  en: {
    // Textes de navigation
    nav: {
      home: 'Home',
      rooms: 'Rooms',
      businessStay: 'Business Stays',
      restaurant: 'Restaurant',
      region: 'Surroundings',
      contact: 'Contact',
    },
    
    // Textes communs
    common: {
      readMore: 'Discover our rooms',
      bookNow: 'Book now',
      contactUs: 'Contact us',
      seeMenu: 'Our restaurant',
      callNow: 'Call now',
      sendEmail: 'Send email',
      discover: 'Discover',
    },
    
    // Page d'accueil
    home: {
      hero: {
        title: 'Welcome to Hôtel Saint-Pierre',
        subtitle: 'An authentic stay in the heart of Normandy',
      },
      about: {
        title: 'Our Hotel',
        description: 'The Hôtel Saint-Pierre is a historic building built in 1905, which preserves the charm and authentic character of Norman heritage. It is located in the heart of the historic center of Villedieu-les-Poêles, a town known for its copper craftsmanship.',
      },
      rooms: {
        title: 'Our Rooms',
        description: 'Discover our comfortable rooms, all equipped with private bathrooms.',
      },
      restaurant: {
        title: 'Our Restaurant',
        description: 'Enjoy traditional Norman cuisine in our restaurant or brasserie.',
      },
      region: {
        title: 'The Region',
        description: 'Explore the wonders of Normandy from our ideally located establishment.',
      },
    },
    
    // Page Restaurant
    restaurant: {
      pageTitle: 'Our Restaurant',
      intro: {
        title: 'The Saint-Pierre Restaurant',
        description: 'Our chef offers traditional Norman cuisine entirely homemade. All our dishes are prepared on site from fresh and local products. In addition to our menus, you can enjoy salads, burgers and other snacking options in a warm and friendly atmosphere.',
      },
      menus: {
        title: 'Our Menus',
        formuleOptions: {
          option1: 'Starter + Main',
          option2: 'Main + Dessert',
        },
      },
      footer: {
        homemade: 'All our dishes are homemade and prepared on site from raw products.',
        priceInfo: 'Net prices, service included.',
        dailyMenu: 'The brasserie menu changes every day, do not hesitate to ask us for the suggestions of the day.',
      },
      sections: {
        starters: 'Starters',
        mains: 'Main Courses',
        desserts: 'Desserts',
      },
      preview: {
        title: 'Our Restaurant',
        cuisine: 'Our cuisine',
        description1: 'Our chef offers traditional Norman cuisine made with fresh, seasonal products. You can enjoy our regional specialties in a warm and friendly atmosphere.',
        button: 'Discover our restaurant',
      },
    },
    
    // Page Chambres
    rooms: {
      pageTitle: 'Our Rooms',
      sectionTitle: 'Our Rooms',
      priceFrom: 'From {price}€*',
      viewDetails: 'View details',
      viewAll: 'View all our rooms',
      intro: {
        title: 'Accommodation',
        description: 'All our rooms are equipped with private bathrooms, television and internet access. We offer different categories to meet all your needs.',
      },
    },
    
    // Page Région
    region: {
      pageTitle: 'Surroundings',
      discoverRegion: 'Discover the region',
      distanceFrom: '{distance} from the hotel',
      otherPlaces: 'Other places to discover',
      advice1: 'Do not hesitate to ask our reception for advice to organize your visits.',
      advice2: 'We can provide you with maps and information on the opening hours of tourist sites.',
      intro: {
        title: 'Discover Normandy',
        description: 'Located in the heart of La Manche, Villedieu-les-Poêles is the ideal starting point to explore the wonders of Normandy.',
      },
      distance: '{distance} from the hotel',
    },
    
    // Page Contact
    contact: {
      pageTitle: 'Contact & Access',
      info: {
        title: 'Contact us',
        address: 'Address',
        phone: 'Phone',
        email: 'Email',
        openingHours: 'Opening hours',
      },
      reservation: {
        title: 'Reservations',
        description: 'To book a room or a table at the restaurant, you can contact us by phone or email. We will respond as soon as possible to confirm your reservation.',
      },
      location: {
        description: 'We are located in the city center of Villedieu-les-Poêles, close to all shops and attractions.',
        parking: 'Private parking available.',
      },
    },
    
    // Footer
    footer: {
      address: 'Address',
      contact: 'Contact',
      about: 'About',
      quickLinks: 'Quick Links',
      openingHours: 'Opening Hours',
      legalNotice: 'Legal Notice',
    },
    
    // Features
    features: {
      title: 'Why Choose Hotel Saint-Pierre',
      items: {
        comfortable: {
          title: 'Comfortable Rooms',
          description: '20 comfortable rooms with private bathroom for a pleasant stay.'
        },
        restaurant: {
          title: 'Traditional Restaurant',
          description: 'Traditional Norman cuisine with fresh, seasonal products.'
        },
        historic: {
          title: 'Historic Building',
          description: 'Built in 1905, our hotel preserves the charm and authentic character of Norman heritage.'
        },
        wifi: {
          title: 'Free Wi-Fi',
          description: 'Stay connected during your stay with our free high-speed Wi-Fi.'
        },
        location: {
          title: 'Central Location',
          description: 'Located in the heart of Villedieu-les-Poêles, close to tourist attractions.'
        },
        welcome: {
          title: 'Warm Welcome',
          description: 'Our team welcomes you warmly to make your stay unforgettable.'
        }
      }
    },
    
    // Cookie Banner
    cookieBanner: {
      message: 'This site uses Google Analytics to analyze traffic. By continuing to browse, you accept our use of cookies.',
      accept: 'Accept',
      decline: 'Decline',
      moreInfo: 'Learn more'
    },
    
    // Legal Notice Page
    legalNotice: {
      pageTitle: 'Legal Notice',
      title: 'Legal Notice',
      lastUpdate: 'Last update: {date}',
      sections: {
        hotelInfo: {
          title: 'Establishment Information',
          content: 'Hotel Saint-Pierre\nSARL with a capital of €10,000\nSIRET: 500 089 487 00010\nVAT Number: FR16500089487\nAddress: 12 Place de la République, 50800 Villedieu-les-Poêles, France\nPhone: +33 (0)2 33 61 00 11\nEmail: st.pierre.hotel@wanadoo.fr'
        },
        hosting: {
          title: 'Website Hosting',
          content: 'This website is hosted by OVH\nSAS with a capital of €50,000,000\nRCS Lille Métropole 424 761 419 00045\nHeadquarters: 2 rue Kellermann - 59100 Roubaix - France\nPhone: +33 (0)8 99 70 17 61'
        },
        intellectualProperty: {
          title: 'Intellectual Property',
          content: 'The entire content of this website (structure, texts, logos, images, photographs, videos, sounds, know-how, etc.) is subject to French and international copyright and intellectual property law. All reproduction rights are reserved, including for downloadable documents and iconographic and photographic representations.\n\nSome photographs used on this site are under Unsplash license, which allows their free use without attribution. Other visual elements are the property of Hotel Saint-Pierre or have been acquired with appropriate usage rights.\n\nThe reproduction of all or part of this site on any electronic or other medium is strictly prohibited without the express authorization of Hotel Saint-Pierre. Any unauthorized use of the site or its content would engage the user\'s liability and constitute an infringement sanctioned by articles L.335-2 and following of the French Intellectual Property Code.'
        },
        cookies: {
          title: 'Cookies Management',
          content: 'This site uses Google Analytics, a web analytics service provided by Google that uses cookies to help us analyze how visitors use the site. The information generated by cookies about your use of the website is transmitted to and stored by Google on servers in the United States.\n\nGoogle Analytics is configured to anonymize your IP address before sending it to Google, which prevents you from being personally identified. Google uses this information to evaluate your use of the website, compile reports on website activity, and provide other services relating to website activity and internet usage.\n\nIn accordance with the General Data Protection Regulation (GDPR) and the European ePrivacy Directive, our site has a cookie consent banner that allows you to accept or reject cookies before they are installed. If you decline cookies, Google Analytics will be automatically disabled for your session.\n\nYou can also refuse the use of cookies by selecting the appropriate settings on your browser. However, please note that if you do this, you may not be able to use all the functionalities of this website.\n\nTo learn more about cookies and how to manage them, visit the CNIL website: www.cnil.fr.'
        },
        disclaimer: {
          title: 'Disclaimer',
          content: 'Hotel Saint-Pierre strives to ensure the accuracy and updating of the information disseminated on this site, which it reserves the right to correct at any time without notice. However, Hotel Saint-Pierre cannot guarantee the accuracy, precision or completeness of the information made available on this site.\n\nConsequently, Hotel Saint-Pierre declines all responsibility for any damage resulting in particular from inaccuracy or inaccuracy of the information available on this site, or for any damage resulting from a fraudulent intrusion by a third party having led to a modification of the information made available on this site.\n\nHotel Saint-Pierre cannot be held responsible for elements beyond its control and for damages that may possibly be suffered by your technical environment, in particular your computers, software, network equipment and any other material used to access or use the service and/or information.'
        },
        links: {
          title: 'Hyperlinks',
          content: 'Hyperlinks established to other sites from www.st-pierre-hotel.com cannot, under any circumstances, engage the responsibility of Hotel Saint-Pierre, particularly with regard to the content of these sites.\n\nHotel Saint-Pierre is not responsible for hyperlinks pointing to its site and disclaims all responsibility regarding the content of sites offering a link to the website www.st-pierre-hotel.com.'
        }
      }
    },
    

    

  },
};

// Fonction utilitaire pour récupérer un texte
export const getText = (lang, path) => {
  const keys = path.split('.');
  let result = texts[lang];
  
  for (const key of keys) {
    if (result && result[key]) {
      result = result[key];
    } else {
      return path; // Retourne la clé si le texte n'est pas trouvé
    }
  }
  
  return result;
};

// Fonction pour formater un texte avec des variables
export const formatText = (text, variables) => {
  if (!variables) return text;
  
  let formattedText = text;
  Object.entries(variables).forEach(([key, value]) => {
    formattedText = formattedText.replace(`{${key}}`, value);
  });
  
  return formattedText;
};
